import state from '../state'

export default {
  usernameRevert() {
    return state.username.split('').reverse().join('')
  }
}



// WEBPACK FOOTER //
// ./src/store/getters/index.js